import React from 'react';
import { withRouter, Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import withQueryParams from 'react-router-query-params';
import PropTypes from 'prop-types';
import Sidebar from '../Sidebar/sidebar';
import DatePickerHeader from '../DatePickerHeader/DatePickerHeader';
import OperationOverview from './overview';
import OperationStatus from './operation-status';
import { strings } from '../locale';
import { filterQueryParams } from '../../utils/url-helper';

const Operations = ({ location, params, queryParams }) => {
  const { pathname } = location;
  const filteredQueryParams = filterQueryParams(queryParams);

  return (
    <div className="page__workflows">
      <Helmet>
        <title> Cumulus Operations </title>
      </Helmet>
      <DatePickerHeader heading={strings.operations} />
      <div className="page__content">
        <div className="wrapper__sidebar">
          <Sidebar currentPath={pathname} params={params} />
          <div className="page__content--shortened">
            <Switch>
              <Route
                exact
                path="/operations"
                render={(props) => (
                  <OperationOverview
                    {...props}
                    queryParams={filteredQueryParams}
                  />
                )}
              />
              <Route
                exact
                path="/operations/operation/:operationId"
                component={OperationStatus}
              />
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
};

Operations.propTypes = {
  location: PropTypes.object,
  params: PropTypes.object,
  queryParams: PropTypes.object,
};

export default withRouter(withQueryParams()(connect()(Operations)));
